import * as React from 'react';
import { getEnv, hasAstroEnv } from "../helpers/env";
import { lazy, Suspense } from "react";

const DevTool = lazy(() => import('../components/hookFormDevToolWrapper.tsx'));

export default function HookFormDevToolLazy(props: any) {
	return (<>
		{hasAstroEnv('MODE') === false && getEnv('PUBLIC_DUMP_ALLOWED') === "yes" && // hide this devtool in astro env
			<Suspense fallback="">
				<DevTool placement="top-right" styles={{button: { position: "absolute", zIndex: "auto" }}} {...props}/>
			</Suspense>
		}
	</>);
}
